/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type TimeLineListArticleRequest = {
  page?: number;
  perPage?: number;
  keyword?: string | null;
  sort?: string | null;
  direction?: TimeLineListArticleRequest.direction | null;
};

export namespace TimeLineListArticleRequest {
  export enum direction {
    ASC = "asc",
    DESC = "desc",
  }
}
